import { createNativeInstance, } from '@transifex/native';
import { saveToStorage, getFromStorage, } from '../preferences/localStorageWrapper';
import { MissingTranslationPolicy } from './missingTranslationPolicy';
// Default token is for the X-Series-Web-Monocle project
const DEFAULT_TOKEN = '1/af8dd5b9fec79f9ea0fb7f7dab4842261ff5d5ec';
const DISABLE_TRANSLATION_FEATURE_FLAG = 'disable_translation';
const USE_TRANSIFEX_HOSTED_CDS_FEATURE_FLAG = 'use_transifex_cds';
const TX_FEATURES_STORAGE_KEY = 'tx_features_storage_key';
const SELF_HOSTED_TRANSIFEX_URL_LIGHTSPEED = 'https://transifex-cds-uoBiexohtahveeY6boh.retail.lightspeed.app';
const edgeFeatures = [
    DISABLE_TRANSLATION_FEATURE_FLAG,
    USE_TRANSIFEX_HOSTED_CDS_FEATURE_FLAG,
];
const getStoredFeatures = () => getFromStorage(TX_FEATURES_STORAGE_KEY) || {};
const getEdgeFeatures = async (features) => {
    const fallbackFeatures = getStoredFeatures();
    try {
        return await fetch(`/api/2.0/features/edge?features=${features.join('&features=')}`)
            .then(response => response.json())
            .then(result => {
            const features = Object.assign(Object.assign({}, fallbackFeatures), result.features);
            saveToStorage(TX_FEATURES_STORAGE_KEY, features);
            return features;
        });
    }
    catch (_a) {
        return fallbackFeatures;
    }
};
const edgeFeaturesPromise = getEdgeFeatures(edgeFeatures);
const getInstanceConfig = (token, tag) => {
    const settings = {
        token,
        filterTags: tag,
        missingPolicy: new MissingTranslationPolicy(),
    };
    const useTxCDS = getStoredFeatures()[USE_TRANSIFEX_HOSTED_CDS_FEATURE_FLAG];
    if (!useTxCDS) {
        settings.cdsHost = SELF_HOSTED_TRANSIFEX_URL_LIGHTSPEED;
    }
    return settings;
};
const isTranslationDisabledPromise = edgeFeaturesPromise.then(features => features[DISABLE_TRANSLATION_FEATURE_FLAG]);
const setCurrentLocaleForInstances = (instances, locale) => {
    return isTranslationDisabledPromise.then(isTranslationDisabled => {
        if (isTranslationDisabled) {
            return Promise.resolve([]);
        }
        return Promise.all(instances.map(instance => instance.setCurrentLocale(locale)));
    });
};
export const createTxInstanceCache = () => {
    const loadedInstances = {};
    let currentLocale;
    /**
     * Get the TXInstance for a given filterTag
     */
    const getTxInstance = (tag, token) => {
        let instance = loadedInstances[tag];
        if (!instance) {
            // Creates and initializes new instance
            instance = createNativeInstance(getInstanceConfig(token || DEFAULT_TOKEN, tag));
            loadedInstances[tag] = instance;
            if (currentLocale) {
                setCurrentLocaleForInstances([instance], currentLocale);
            }
        }
        return instance;
    };
    /**
     * Set the language for all TXInstance managed by this cache
     */
    const setCurrentLocale = (locale) => {
        currentLocale = locale;
        return isTranslationDisabledPromise.then(isTranslationDisabled => {
            if (isTranslationDisabled) {
                return Promise.resolve([]);
            }
            return setCurrentLocaleForInstances(Object.values(loadedInstances), locale);
        });
    };
    /**
     * Get the current locale
     */
    const getCurrentLocale = () => currentLocale;
    /**
     * Directly add a tx instance to the txManager.
     */
    const addTxInstance = (instance, tag, token, key) => {
        instance.init(getInstanceConfig(token || DEFAULT_TOKEN, tag));
        loadedInstances[key || tag] = instance;
        if (currentLocale) {
            setCurrentLocaleForInstances([instance], currentLocale);
        }
    };
    return { getTxInstance, addTxInstance, setCurrentLocale, getCurrentLocale };
};
